import React, { useState } from "react";
import { setDashboardToken } from "helpers/dashboard/dashboardStorage";

const OwnerDashboardLogin = ({ onSuccess, errorMessage }) => {
  const [password, setPassword] = useState("");
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [localError, setLocalError] = useState("");

  const handleSubmit = async (event) => {
    event.preventDefault();
    setLocalError("");
    setIsSubmitting(true);

    try {
      setDashboardToken(password.trim());
      await onSuccess(password.trim());
    } catch (error) {
      setLocalError(error.message || "Could not sign in");
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <div className="owner-dashboard__login">
      <div className="owner-dashboard__login-card">
        <p className="owner-dashboard__eyebrow">Ace Gymnastics</p>
        <h1>Enrollment dashboard</h1>
        <p className="owner-dashboard__login-lead">
        Password-protected recommendations from your live schedule and website
        enrollment data — what to add, promote, or fix.
        </p>

        <form onSubmit={handleSubmit}>
          <label htmlFor="dashboard-password">Dashboard password</label>
          <input
            id="dashboard-password"
            type="password"
            autoComplete="current-password"
            value={password}
            onChange={(event) => setPassword(event.target.value)}
            placeholder="Enter password"
            required
          />

          {(localError || errorMessage) && (
            <p className="owner-dashboard__error" role="alert">
              {localError || errorMessage}
            </p>
          )}

          <button type="submit" className="site-btn site-btn--primary" disabled={isSubmitting}>
            {isSubmitting ? "Signing in…" : "View dashboard"}
          </button>
        </form>
      </div>
    </div>
  );
};

export default OwnerDashboardLogin;
